import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../style/login.css";
import { ROUTES } from "../Routes/routes";
import { PredefinedWord } from "../Routes/Predefined";
import { apiAxios } from "../utils/apiAxios";
import { useEffect } from "react";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [remember, setRemember] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleSubmit = async () => {
    //e.preventDefault();

    if (!username.trim() || !password.trim()) {
      toast.warn("Please enter both username and password.");
      return;
    }

    setLoading(true);

    try {
      const { data } = await apiAxios.post(`${API_BASE}/Auth/login`, {
        username: username.trim(),
        password: password.trim(),
      });

      // Defensive checks
      if (!data?.token || !data?.user) {
        throw new Error("Invalid login response");
      }

      sessionStorage.setItem("token", data.token);
      window.dispatchEvent(new Event("storage"));
      sessionStorage.setItem("user", JSON.stringify(data.user));

      if (remember) {
        localStorage.setItem(
          "rememberMe",
          JSON.stringify({
            username,
            password,
          })
        );
      } else {
        localStorage.removeItem("rememberMe");
      }

      const role = data.user?.roleName?.toLowerCase();

      switch (role) {
        // case PredefinedWord.Roles.DENTIST: {
        //   const clinics = data.user?.clinicDetails ?? [];
        //   const hasApprovedClinic = clinics.some((c: any) => c?.isApprove === true);

        //   navigate(
        //     hasApprovedClinic
        //       ? ROUTES.DENTIST.DENTIST_DASHBOARD
        //       : ROUTES.DENTIST.CLINIC_DETAILS
        //   );
        //   break;
        // }
        case PredefinedWord.Roles.DENTIST: {

          const clinics = data.user?.clinicDetails ?? [];

          const approvedClinics = clinics.filter(
            (c: any) => c?.isApprove === true
          );

          const hasApprovedClinic = approvedClinics.length > 0;

          // ✅ AUTO SELECT FIRST APPROVED CLINIC
          if (hasApprovedClinic) {

            const firstClinic = approvedClinics[0];

            sessionStorage.setItem(
              "selectedClinicId",
              firstClinic.clinicID.toString()
            );

            sessionStorage.setItem(
              "selectedClinic",
              JSON.stringify(firstClinic)
            );

            // optional
            window.dispatchEvent(new Event("clinicChanged"));
          }

          navigate(
            hasApprovedClinic
              ? ROUTES.DENTIST.DENTIST_DASHBOARD
              : ROUTES.DENTIST.CLINIC_DETAILS
          );

          break;
        }

        case PredefinedWord.Roles.MILLING_HUB: {
          if (!data.user?.isApproved) {
            toast.info(
              "Your Milling Hub account is pending approval. Please wait for administrator approval."
            );
            break;
          }
          navigate(ROUTES.MILLING.MILLING_HUB_DASHBOARD);
          break;
        }

        case PredefinedWord.Roles.CENTRAL_HUB:
          navigate(ROUTES.CENTRAL.CENTRAL_HUB_DashboardAdminCentralHub);
          break;

        case PredefinedWord.Roles.CENTRAL.MANAGER:
          navigate(ROUTES.CENTRAL.Manager.MANAGER_DashboardManagerCentralHub);
          break;

        case PredefinedWord.Roles.CENTRAL.DESIGNER:
          navigate(ROUTES.CENTRAL.Designer.DESIGNER_DASHBOARD);
          break;

        case PredefinedWord.Roles.DELIVERYPARTNER:
          navigate(ROUTES.DELIVERYPARTNER.DELIVERYPARTNER_DELIVERYPARTNERDASHBOARD);
          break;

        default:
          toast.error("Unauthorized role");
          navigate(ROUTES.LOGIN);
      }
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
        "Invalid username or password"
      );
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const saved = localStorage.getItem("rememberMe");

    if (saved) {
      const data = JSON.parse(saved);
      setUsername(data.username);
      setPassword(data.password);
      setRemember(true);
    }
  }, []);



  return (

    <div className="login-wrapper">
      <div className="login-bg">
        <motion.div
          className="bg-blob blob1"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
        />
        <motion.div
          className="bg-blob blob2"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
        />
        <motion.div
          className="bg-blob blob3"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
        />
      </div>

      {/* Main Login Box */}
      <motion.div
        className="login-box"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        {/* Left Section */}
        <motion.div
          className="login-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2 className="welcome-to-login">
            Welcome to <span>ToothZap</span>
          </h2>
          <p>Login to manage your dental care</p>

          <form>
            <div className="input-field">
              <i className="fa fa-user icon"></i>
              <input
                type="text"
                placeholder="Email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="input-field position-relative" >
              <i className="fa fa-lock icon position-absolute" style={{ left: "10px", top: "12px", color: "#888" }}></i>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control ps-4 pe-5"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <i
                className={`bi ${showPassword ? "bi-eye " : " bi-eye-slash"}`}
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "12px",
                  cursor: "pointer",
                  color: "#888",
                }}
              ></i>
            </div>
            {/* <div className="forgot">
              <a
                href={ROUTES.FORGOT_PASSWORD}
                className="text-decoration-none"
              >
                Forgot password?
              </a>
            </div> */}

            <div className="login-options-row">
              <label className="remember-me">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                />
                <span className="checkmark"></span>
                <span className="label-text">Remember Me</span>
              </label>

              <a
                href={ROUTES.FORGOT_PASSWORD}
                className="forgot-link"
              >
                Forgot password?
              </a>
            </div>

            <button type="button" className="btn-login" disabled={loading} onClick={handleSubmit}>
              {loading ? "Logging in..." : "Log in"}
            </button>

            <div className="divider">
              <small>
                Don’t have an account?{" "}
                <a
                  onClick={() => navigate(ROUTES.REGISTER)}
                  className="text-primary text-decoration-none"
                  style={{ cursor: "pointer" }}
                >
                  Register now
                </a>
              </small>
            </div>
          </form>
        </motion.div>

        {/* Right Image Section */}
        <motion.div
          className="login-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >

          <span className="float-circle circle-1"></span>
          <span className="float-circle circle-2"></span>
          <span className="float-circle circle-3"></span>
          <span className="float-circle circle-4"></span>
          <span className="float-circle circle-5"></span>
          <span className="float-circle circle-6"></span>
          <span className="float-circle circle-7"></span>
          <span className="float-circle circle-8"></span>

          <img src={PredefinedWord.images.rightbgimage} alt={PredefinedWord.images.rightbgimagealt} className="login-image" />
        </motion.div>
      </motion.div>

    </div>
  );
};

export default Login;
